import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {useFilters} from '../../components/filters';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls, normalizeRuStr} from '../../components/utils';
import {Origin, useOriginsQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {OriginView} from './view';
import {getAllTitles} from '../../components/render-helpers';
import {OriginFilters, originFilters} from './filters';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const OriginsPage: React.FC<Props> = () => {
	const filters = useFilters(originFilters);

	const {data, loading, error} = useOriginsQuery({
		ssr: true,
		variables: {filters: filters.values},
	});

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.origins || [],
		id: query.id as string,
		loading,
		route: 'origin',
		baseRoute: 'origins',
		sidebarHeader: (origin) => origin.title,
		sidebarSecondary: (origin) => origin.feat.replace(/{@.*?, (.*?)}/, '$1'),
		filterFn: (origin, str) => {
			const names = getAllTitles(origin as Origin);
			return names.some((name) => normalizeRuStr(name).includes(normalizeRuStr(str)));
		},
		onOpenFilters: filters.toggle,
		isFiltersSet: filters.isSet,
	});

	const title = showView && selected ? selected.title : 'Предыстории';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="origins" />}
			{notFound && <NotFoundSeo />}
			<OriginFilters filters={filters} />
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<OriginView originId={selectedId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите черту</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
